<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.chs">
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Tea Flavin</span>
        </b>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16pt;font-family:宋体;">
              <br>
            </span>
          </u>
        </b>
      </p>
      <table
        style="border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">ITEMS</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">SPECIFICATION</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">RESULTS</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">Appearance</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Yellow
                  fine powder with characteristic odor
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">Identification:</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Passes
                  all criteria tests
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="3" style="border:solid windowtext 1.0pt;" valign="top" width="335">
              <p>
                <span style="font-size:12px;font-family:'} ';">Assay</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Total
                  Tea Polyphenols (By UV)
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:宋体;">≥</span>
                <span style="font-size:12px;font-family:'} ';">60.0%</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">62.1%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">Thcaflavins</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:宋体;">≥</span>
                <span style="font-size:12px;font-family:'} ';">2.0%</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">2.3%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Total
                  Catechins
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">Caffeine</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">7.8%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Sieve
                  analysis
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  100%pass
                  80 mesh
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Loss
                  on drying
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:宋体;">≤</span>
                <span style="font-size:12px;font-family:'} ';">5.0%</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">3.3%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Heavy
                  Metal
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:宋体;">≤</span>
                <span style="font-size:12px;font-family:'} ';">10ppm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">As</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:宋体;">≤</span>
                <span style="font-size:12px;font-family:'} ';">2ppm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">Ash</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:宋体;">≤</span>
                <span style="font-size:12px;font-family:'} ';">2.0%</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">1.6%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="3" style="border:solid windowtext 1.0pt;" valign="top" width="335">
              <p>
                <span style="font-size:12px;font-family:'} ';">Microbiology</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Total
                  plate count
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">&lt;1000cfu/g</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Yeast
                  &amp; mould
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">&lt;100cfu/g</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Conforms</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  E.
                  Coli
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">Negative</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Negative</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="127">
              <p>
                <span style="font-size:12px;font-family:'} ';">Salmonella</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="132">
              <p>
                <span style="font-size:12px;font-family:'} ';">Negative</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="76">
              <p>
                <span style="font-size:12px;font-family:'} ';">Negative</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <b>
        <u></u>
      </b>
      <p></p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.src">
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Instant Tea</span>
        </b>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        chs: require("../../../assets/img/common/chs.jpg"),
        src: require("../../../assets/img/common/src.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/chs.vue